import { useState } from 'react';
import { Plus, Mail, FileText, Video, Zap, CheckCircle2, ArrowRight, UserPlus } from 'lucide-react';

const ACTIONS = [
  { id: 'email',    label: 'Neue E-Mail',     icon: Mail,         color: 'text-[#338edc]' },
  { id: 'note',     label: 'Notiz',           icon: FileText,     color: 'text-[var(--text-secondary)]' },
  { id: 'meeting',  label: 'Meeting',         icon: Video,        color: 'text-[#EA580C]' },
  { id: 'workflow', label: 'Workflow starten',icon: Zap,          color: 'text-[#338edc]' },
  { id: 'task',     label: 'Aufgabe',         icon: CheckCircle2, color: 'text-emerald-600' },
  { id: 'stage',    label: 'Status ändern',   icon: ArrowRight,   color: 'text-[var(--text-secondary)]' },
  { id: 'owner',    label: 'Owner zuweisen',  icon: UserPlus,     color: 'text-[var(--text-secondary)]' },
];

export default function FloatingActionButton({ onAction }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
        {open && (
          <div className="flex flex-col items-end gap-2 mb-2">
            {ACTIONS.map((a) => {
              const Icon = a.icon;
              return (
                <button
                  key={a.id}
                  onClick={() => { setOpen(false); onAction?.(a.id); }}
                  className="flex items-center gap-2 group focus:outline-none"
                >
                  <span className="bg-[var(--bg-card)] border border-[var(--border-card)] rounded-lg px-3 py-1 text-[12px] text-[var(--text-primary)] shadow-sm group-hover:shadow-md group-hover:bg-[var(--bg-inset)] transition-all">
                    {a.label}
                  </span>
                  <span className="w-10 h-10 rounded-full bg-[var(--bg-card)] border border-[var(--border-card)] shadow-sm group-hover:shadow-md group-hover:bg-[var(--bg-inset)] flex items-center justify-center transition-all">
                    <Icon className={`w-4 h-4 ${a.color}`} />
                  </span>
                </button>
              );
            })}
          </div>
        )}
        <button
          onClick={() => setOpen((v) => !v)}
          className={`w-14 h-14 rounded-full bg-[#338edc] text-white shadow-lg hover:shadow-xl flex items-center justify-center transition-all ${open ? 'rotate-45' : ''}`}
          title="Aktionen"
        >
          <Plus className="w-6 h-6" />
        </button>
      </div>
    </>
  );
}
